<template>
    <div :style="{ width:'100%', height:'100%', 'background-repeat':'no-repeat', 'background-position':'50% 50%', 'background-size':'contain', backgroundImage:`url(${bgImg})` }">
    </div>
</template>
<script>
    import bgImg from '@/assets/tabs-bg-4.png';
    export default {
        data(){
            return {
                bgImg
            }
        }
    }
</script>